import { useState } from 'react'
import s from './Checklist.scss'
import { InputContainer, Checkbox } from 'components/ideal-core-ui'
import { Button } from 'reactstrap'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'

const Checklist = ({
  checklist,
  addItem,
  deleteItem,
  deleteChecklist,
  setEditedChecklist,
  setEditedItem
}) => {
  const [itemName, setItemName] = useState('')

  return (
    <div className={s.checklist} key={checklist.id}>
      <h6>
        {checklist.title}
        <FaPencilAlt
          className={s.removeChecklist}
          onClick={() => setEditedChecklist({ ...checklist })}
        />
        <FaTrashAlt className={s.removeChecklist} onClick={() => deleteChecklist(checklist.id)} />
      </h6>
      <div className={s.itemsWrapper}>
        {checklist.items.length ? (
          checklist.items.map(item => (
            <div className={s.itemWrapper} key={item.id}>
              <div className={s.item}>
                <Checkbox size="md" isChecked={false} isDisabled />
                <span className={s.itemName}>{item.name}</span>
                <FaPencilAlt
                  className={s.editItem}
                  onClick={() => setEditedItem({ item, checklistId: checklist.id })}
                />
                <FaTrashAlt
                  className={s.removeItem}
                  onClick={() => deleteItem(checklist.id, item.id)}
                />
              </div>
            </div>
          ))
        ) : (
          <div>
            <i>This checklist has no items</i>
          </div>
        )}
        <InputContainer
          type="text"
          text={itemName || ''}
          placeholder="Add Item"
          cb={value => setItemName(value)}
          classname={s.addItemInput}
        />
        <Button
          className={s.greenBtn}
          onClick={() => {
            addItem(checklist.id, itemName)
            setItemName('')
          }}
        >
          Add
        </Button>
      </div>
    </div>
  )
}

export default Checklist
